module.exports = __webpack_public_path__ + "static/media/img3-1.27e717cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/biosense/diff/img3-1.png
// module id = 2096
// module chunks = 3